// Funkce pro validaci

import * as Sentry from '@sentry/browser';
import { FlashMessage } from '@components';
import * as els from './forumElements';

interface IsTextValid {
  content: string;
  length?: number;
  shake: HTMLElement;
}

export const isTextValid = ({ content, length = 5, shake }: IsTextValid) => {
  // Pokud je text kratší než požadovaný počet znaků
  if (content.length < length) {
    // Zatřást tlačítkem
    shake.classList.add(els.CLASS_BUTTON_SHAKED);

    (async () => {
      // Zobrazit chybovou hlášku
      await FlashMessage({ msg: `Komentář musí mít minimálně ${length} znaků.`, type: 'error' });
    })()
      .then(() => {})
      .catch((err) => {
        Sentry.captureException(err);
      });

    // Odebrat třídu pro zatřesení tlačítka
    setTimeout(() => {
      shake.classList.remove(els.CLASS_BUTTON_SHAKED);
    }, 3000);
    return false;
  }

  return true;
};
